import React from 'react';
import { Link } from 'react-router-dom';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import BuyerEstimationTransaction from '../../Models/buyerEstimationTransaction';
import { Header, Footer } from '../Common';
import { Spinner } from 'reactstrap';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class BuyerComCan extends React.Component {
    constructor(props) {
        super(props);
        if (localStorage.getItem('info') === null || localStorage.getItem('info') === '') {
            window.location.href = '/login';
        };
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        var id = logged_user.id;
        this.state = {
            minHeight: "475px",
            user: id,
            completes: [],
            status: ''
        };
        this.getResponseAll();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getResponseAll() {
        BuyerEstimationTransaction.getMyCompletes(this.state.user).then(res => {
            this.setState({ completes: res.data.payload, status: res.data.status })
            console.log(this.state.completes)
        })
    }

    sellerComCanView() {
        if (this.state.status === 200) {
            if (this.state.completes.length === 0) {
                return (
                    <div>
                        <div className="mt-3"><span><img alt="" src={require("../../assets/images/message.png")} height="40" width='40' />&nbsp;&nbsp;</span></div>
                        <div className="mt-3"><span>完成やキャンセルした件ありません!</span></div>
                    </div>
                )
            } else {
                return (
                    <div style={{ backgroundColor: "white", minHeight: "550px", textAlign: "left" }}>
                        <div className="col-md-12 row ml-2" style={{ paddingTop: "3%", paddingBottom: "2%" }}>
                            <div className="col-md-6 font_12">
                                <b><i>取引内容 </i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>完成日</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>取引金額</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>状況</i></b>
                            </div>
                        </div>
                        {this.state.completes.map((req, i = 1) =>
                            <div className="col-md-12 row ml-2" key={req.id} style={{ borderBottom: "1px solid #fbf8f8", paddingTop: "3%", paddingBottom: "2%" }}>
                                <div className="col-md-6 font_12">
                                    {/* <span className="font_12"> サービスID: {req.service_id}</span><br /> */}
                                    <Link to={{
                                        pathname: `/buyer-request-details`,
                                        state: {
                                            id: req.id
                                        }
                                    }}>
                                        <b>{req.title}</b>
                                    </Link>
                                </div>
                                <div className="col-md-2 font_12" style={{}}>
                                    {(JSON.stringify(req.completion_date)).substring(1, 11)}
                                    {/* {req.proposed_delivery_time} */}
                                </div>
                                <div className="col-md-2 font_12" style={{}}>
                                    {req.proposed_budget}
                                </div>
                                <div className="col-md-2">
                                    {(() => {
                                        if (req.current_status === 'TRADING') {
                                            return (
                                                <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}> 取引中</div>
                                            )
                                        } else if (req.current_status === 'UNDERESTIMATION') {
                                            return (
                                                <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>相談中</div>
                                            )
                                        } else if (req.current_status === 'COMPLETE') {
                                            return (
                                                <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>完成</div>
                                            )
                                        } else if (req.current_status === 'CANCEL') {
                                            return (
                                                <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>キャンセル</div>
                                            )
                                        } else if (req.current_status === 'DECLINED') {
                                            return (
                                                <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>拒否</div>
                                            )
                                        } else {
                                            return (
                                                <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>不明</div>
                                            )
                                        }
                                    })()}
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '100px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }

    }

    sellerComCanViewSmall() {
        if (this.state.status === 200) {
            if (this.state.completes.length === 0) {
                return (
                    <div>
                        <div className="mt-3"><span><img alt="" src={require("../../assets/images/message.png")} height="40" width='40' />&nbsp;&nbsp;</span></div>
                        <div className="mt-3"><span>完成やキャンセルした件ありません!</span></div>
                    </div>
                )
            } else {
                return (
                    <div style={{ backgroundColor: "white", minHeight: "550px", textAlign: "left" }}>
                        {this.state.completes.map((req, i = 1) =>
                            <div className="ml-2 pl-1" key={req.id} style={{ borderBottom: "1px solid #dadada", paddingTop: "3%", paddingBottom: "3%" }}>
                                <div className="font_12 pb-3" style={{paddingLeft: "15px"}}>
                                    {/* <span className="font_12"> サービスID: {req.service_id}</span><br /> */}
                                    <Link to={{
                                        pathname: `/buyer-request-details`,
                                        state: {
                                            id: req.id
                                        }
                                    }}>
                                        <b class="gray">{req.title}</b>
                                    </Link>
                                </div>
                                <div className="font_12 row col" style={{}}>
                                    <div className="col-4 text-left">{req.proposed_budget}</div>
                                    <div className="col-4 text-right remove_pads">{(JSON.stringify(req.completion_date)).substring(1, 11)}</div>
                                    {/* {req.proposed_delivery_time} */}
                                    <div className="col-4 text-right pr-1">
                                        {(() => {
                                            if (req.current_status === 'TRADING') {
                                                return (
                                                    <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}> 取引中</div>
                                                )
                                            } else if (req.current_status === 'UNDERESTIMATION') {
                                                return (
                                                    <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>相談中</div>
                                                )
                                            } else if (req.current_status === 'COMPLETE') {
                                                return (
                                                    <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>完成</div>
                                                )
                                            } else if (req.current_status === 'CANCEL') {
                                                return (
                                                    <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>キャンセル</div>
                                                )
                                            } else if (req.current_status === 'DECLINED') {
                                                return (
                                                    <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>拒否</div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{  borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>不明</div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '100px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }

    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font" style={{textAlign:'left', width: "100%" ,fontSize:'20px'}}>
                                    購入取引
                                        </div>
                                <div className="chest" >
                                    <div>
                                        <div className="row" style={{ marginLeft: '0px', marginRight: '-8px' }}>
                                            <div className="navigation" style={{ fontSize: "9px",width: "33%",paddingRight:'3%'}}>
                                                <Link to={'/buyer-estimate'} className="h-a" href="">見積り</Link>
                                            </div>
                                            <div className="navigation"style={{ fontSize: "9px",width: "33%",paddingRight:'3%'}}>
                                                <Link to={'/buyer-transaction'} className="h-a" href="">取引中</Link>
                                            </div>
                                            <div className="navigation" style={{ borderTop: "4px solid #67b1e2", borderBottom: "1px solid white", borderRight: "none", fontSize: "9px",width: "32%",paddingRight:'3%' }}>
                                                <Link to={'/buyer-complete-cancel'} className="h-a" href=""><b>完成・キャンセル</b></Link>
                                            </div>
                                        </div>
                                        <div>
                                            <div colSpan="3">
                                                <div className="min-height">
                                                    {this.sellerComCanViewSmall()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    <BuyerSidebar />
                                </div>
                                <div className="col-md-8">
                                    <div className="mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                        購入取引
                                    </div>
                                    <div className="chest" >
                                        <div>
                                            <div className="row" style={{ marginLeft: '0px', marginRight: '-8px' }}>
                                                <div className="navigation">
                                                    <Link to={'/buyer-estimate'} className="h-a" href="">見積り</Link>
                                                </div>
                                                <div className="navigation">
                                                    <Link to={'/buyer-transaction'} className="h-a" href="">取引中</Link>
                                                </div>
                                                <div className="navigation" style={{ borderTop: "4px solid #67b1e2", borderBottom: "1px solid white", borderRight: "none" }}>
                                                    <Link to={'/buyer-complete-cancel'} className="h-a" href=""><b>完成・キャンセル</b></Link>
                                                </div>
                                            </div>
                                            <div>
                                                <div colSpan="3">
                                                    <div className="min-height">
                                                        {this.sellerComCanView()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { BuyerComCan };